import { RoutePermittedRole } from "shared/constants/AppConst";
import { isModuleAuthorized } from "@crema/utility/Utils";
import Error403 from "pages/errorPages/Error403";
import CustomerCareCreateIndex from "./customer_page/CustomerPageCreate";
import CustomerCareUpdateIndex from "./customer_page/CustomerCarePageUpdate";
import Customer from "./customer_page";

export const CustomerMasterConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/customerCare/CustomerPageCreate",
    exact: true,
    element: isModuleAuthorized("Add CC Lead") ? <CustomerCareCreateIndex /> : <Error403 />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/customerCare/:pageID",
    exact: true,
    element: isModuleAuthorized("Edit Customer") ? <CustomerCareUpdateIndex /> : <Error403 />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/customerCare/list",
    exact: true,
    element: isModuleAuthorized("Manage CC Lead Page") ? <Customer /> : <Error403 />,
  },
];
